if(typeof FN == 'undefined') FN = {};


FN.campaignParam = {
  config: {
    urlParamName: 'campaign'
  },
  
  
  init: function() {
    var campaignParamValue = FN.helpers.getURLParameterByName(FN.campaignParam.config.urlParamName);
    
    if(campaignParamValue){
      Cookies.set(FN.campaignParam.config.urlParamName, campaignParamValue, { 
        expires: 30, 
        path: '/',
        sameSite: 'Lax'
      });
    }
  }
};




$(window).on('load', FN.campaignParam.init);